import { useTranslation } from '@exam-room/translations';

import LoadingSpinner from './LoadingSpinner';

export default function ExamLoadingScreen() {
  const { t } = useTranslation();
  return (
    <div className='grid h-dvh w-screen place-items-center'>
      <div className='flex flex-col items-center gap-4 p-6'>
        <LoadingSpinner className='h-12 w-12' />
        <div className='flex flex-col items-center gap-1'>
          <p className='text-text-primary text-lg font-semibold'>{t('examLoadingScreen.title')}</p>
          <p className='text-text-secondary'>{t('examLoadingScreen.description')}</p>
        </div>
      </div>
    </div>
  );
}
